import { Grid, makeStyles, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import clsx from 'clsx';
import i18n from 'i18n';
import React from 'react';
import Loading from 'components/Loading';
import RedoIcon from '@material-ui/icons/Redo';
import WarningIcon from '@material-ui/icons/Warning';
import {
  InstanceStateEnum,
  PublishImageEnum,
} from 'modules/environments/interfaces';
import { StatusIcon } from 'components/TableItems';
import { styleStatus } from './styles';

const useStyles = makeStyles(styleStatus);

export const getStatusText = (status: InstanceStateEnum | PublishImageEnum) => {
  const options = {
    [InstanceStateEnum.PENDING]: i18n.t('ENVIRONMENTS_PAGE.STATUS.PENDING_KEY'),
    [InstanceStateEnum.RUNNING]: i18n.t('PUBLISH_RUNNING_KEY'),
    [InstanceStateEnum.STOPPING]: i18n.t(
      'ENVIRONMENTS_PAGE.STATUS.STOPPING_KEY'
    ),
    [InstanceStateEnum.STOPPED]: i18n.t('ENVIRONMENTS_PAGE.STATUS.STOPPED_KEY'),
    [PublishImageEnum.SKIPPED]: i18n.t('PUBLISH_SKIPPED_KEY'),
    [PublishImageEnum.WARNING]: i18n.t('PUBLISH_WARNING_KEY'),
    [PublishImageEnum.SUCCESS]: i18n.t('PUBLISH_SUCCESS_KEY'),
    [PublishImageEnum.FAILED]: i18n.t('PUBLISH_FAILED_KEY'),
    [PublishImageEnum.TIMEOUT]: i18n.t('PUBLISH_TIMEOUT_KEY'),
    null: i18n.t('ENVIRONMENTS_PAGE.STATUS.NOT_FOUND'),
  };

  return options[status] || i18n.t('ENVIRONMENTS_PAGE.STATUS.PENDING_KEY');
};

export const isFinalizingState = (
  state: InstanceStateEnum | PublishImageEnum
) => {
  if (!state) return true;
  return [
    InstanceStateEnum.RUNNING,
    InstanceStateEnum.STOPPED,
    InstanceStateEnum.TERMINATED,
    PublishImageEnum.SKIPPED,
    PublishImageEnum.WARNING,
    PublishImageEnum.SUCCESS,
    PublishImageEnum.FAILED,
    PublishImageEnum.TIMEOUT,
  ].includes(state);
};

export interface Props {
  hiddenText?: boolean;
  value: InstanceStateEnum | PublishImageEnum;
}

const StatusInstance = ({ value, hiddenText }: Props) => {
  const classes = useStyles();

  const getCustom = () => {
    const defaultCustom = {
      icon: <Loading size={15} />,
      color: '',
    };
    const customs = {
      [InstanceStateEnum.RUNNING]: {
        icon: <Loading size={15} />,
        color: '',
      },
      [InstanceStateEnum.STOPPED]: {
        icon: <StatusIcon status="inactive" />,
      },
      [InstanceStateEnum.TERMINATED]: {
        icon: <CloseIcon fontSizeAdjust={15} />,
        color: 'gray',
      },
      [PublishImageEnum.SUCCESS]: {
        icon: <StatusIcon status="success" />,
      },
      [PublishImageEnum.FAILED]: {
        icon: <StatusIcon status="blocked" />,
      },
      [PublishImageEnum.TIMEOUT]: {
        icon: <StatusIcon status="blocked" />,
      },
      [PublishImageEnum.SKIPPED]: {
        icon: <RedoIcon fontSizeAdjust={15} />,
        color: 'gray',
      },
      [PublishImageEnum.WARNING]: {
        icon: <WarningIcon fontSizeAdjust={15} />,
        color: 'yellow',
      },
      null: {
        icon: <CloseIcon fontSizeAdjust={15} />,
        color: 'gray',
      },
    };

    return customs[value] || defaultCustom;
  };

  return (
    <Grid container wrap="nowrap" alignItems="center">
      <span className={clsx(classes.icon, classes[getCustom().color])}>
        {getCustom().icon}
      </span>
      {!hiddenText && (
        <Typography variant="body2" className={classes.statusText}>
          {getStatusText(value)}
        </Typography>
      )}
    </Grid>
  );
};

export default StatusInstance;
